/* eslint-disable max-statements */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { BulkBatchUpload } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batch: BulkBatchUpload;
}

export const useBulkUploadBatches = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batch }: HookProps) => {
      const formData = new FormData();
      if (batch.files) {
        for (const file of batch.files) {
          formData.append('files', file);
        }
        formData.append('name', batch.name);
        formData.append('customer', batch.customer);
        formData.append('template', batch.template);
        formData.append('brokerId', batch.broker || '');
        formData.append('hvSplittingCustomer', batch.hvSplittingCustomer || '');
        formData.append('hvSplittingTemplate', batch.hvSplittingTemplate || '');
        formData.append('h7ExcludedCustomer', batch.h7ExcludedCustomer || '');
        formData.append('h7ExcludedTemplate', batch.h7ExcludedTemplate || '');

        const result = await apiClient.batchesCore.bulkUpload.mutation({ body: formData });
        if (result.status !== 200) throw result.body;

        return result.body;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      toast.success(`Bulk upload was successful!`);
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error uploading the batches!');
    },
  });
};
